export enum DeliveryMethodProviderEnum {
  NetGlobal = 'netglobal',
  WithoutIntegration = 'without-integration',
}

export interface NetGlobalDeliveryMethodConfiguration {
  netGlobalServiceId: number;
  netGlobalCompanyId: number;
  netGlobalShipmentTypeId: number;
  netGlobalServiceTypeId: number;
  netGlobalSenderId: number;
  netGlobalSenderAddressId: number;
  netGlobalContactId: number;
  netGlobalOrderInternationalTypeId: number;
  netGlobalShipmentTermsId: number;
  netGlobalBusinessTypeId: number;
}

export interface DeliveryMethod {
  _id?: string;
  name: string;
  provider: DeliveryMethodProviderEnum;
  isActive: boolean;
  fee: number;
  estimatedDeliveryDaysMin: number;
  estimatedDeliveryDaysMax: number;
  configuration: Partial<NetGlobalDeliveryMethodConfiguration> | Record<string, unknown>;
  isDeleted?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}
